module.exports = __webpack_public_path__ + "img/1.e20566af.png";